import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 381A61B9-0D73-4CB8-B525-C67697443F43
 * name home-analytics
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-analytics.svg
 * tags
 * - Home Automation 
 */
export const HomeAnalyticsIcon = createSvgIcon(<><path d="M12,3L2,12H5V20H19V12H22M9,18H7V12H9M13,18H11V10H13M17,18H15V14H17" /></>, 'HomeAnalyticsIcon');
export default HomeAnalyticsIcon